import { render, staticRenderFns } from "./AIBusinessPromoterDetail.vue?vue&type=template&id=1e7beac8&scoped=true&"
import script from "./AIBusinessPromoterDetail.vue?vue&type=script&lang=js&"
export * from "./AIBusinessPromoterDetail.vue?vue&type=script&lang=js&"
import style0 from "./AIBusinessPromoterDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AIBusinessPromoterDetail.vue?vue&type=style&index=1&id=1e7beac8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7beac8",
  null
  
)

export default component.exports